import IconQuoteSrc from "@/assets/images/icon-quote@2x.png"
import colorVars from "@/assets/styles/colorVars"
import React, { FC } from "react"
import { up } from "styled-breakpoints"
import styled from "styled-components"

export interface ITestimonial {
  author?: string
  description?: string
  quote?: string
}

export interface TestimonialProps {
  data?: ITestimonial
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px 0;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  min-height: 310px;
  padding: 32px;
  margin: 0 16px;
  color: white;
  pointer-events: none;
  background: rgb(255 255 255 / 10%);
  border-radius: 24px;
  box-shadow: inset 0 0 0 1px rgb(255 255 255 / 10%);

  ${up("sm")} {
    margin: 0 32px;
  }

  ${up("md")} {
    margin: 0;
  }

  /* Quote icon */
  &::before {
    display: block;
    width: 24px;
    height: 24px;
    margin-bottom: 16px;
    content: "";
    background: url("${IconQuoteSrc}") no-repeat center center;
    background-size: 24px 24px;
  }
`
const Quote = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 33.6px;
`
const Author = styled.div`
  margin-top: auto;
  font-size: 18px;
  font-weight: 600;
  line-height: 21.6px;
`
const Description = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${colorVars.text.gray};
`

export const Testimonial: FC<TestimonialProps> = ({ data }) => {
  if (!data) return null

  const { author, description, quote } = data

  return (
    <Wrapper>
      {quote && <Quote>{quote}</Quote>}
      {author && <Author>{author}</Author>}
      {description && <Description>{description}</Description>}
    </Wrapper>
  )
}
